/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Please_Try_AgainInputs */

const en_please_try_again = /** @type {(inputs: Please_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try again.`)
};

const nl_please_try_again = /** @type {(inputs: Please_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probeer het opnieuw.`)
};

/**
* | output |
* | --- |
* | "Please try again." |
*
* @param {Please_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const please_try_again = /** @type {((inputs?: Please_Try_AgainInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Please_Try_AgainInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_please_try_again(inputs)
	return en_please_try_again(inputs)
});